export default __webpack_public_path__ + "static/media/minisite-pagetype-register.ae030304.svg";